// Extensiones de adjuntos permitidas para subir en documentos relacionados 
const EXTENSIONES_ADJUNTOS_PRESENTACION = [
  'CSV',
  'DOCX',
  'JPEG',
  'JPG',
  'MPEG',
  'MP3',
  'MP4',
  'ODG',
  'ODP',
  'ODS',
  'ODT',
  'PDF',
  'PNG',
  'PPTX',
  'RTF',
  'SVG',
  'TIFF',
  'TXT',
  'XLSX',
  'ZIP',
]

export {
  EXTENSIONES_ADJUNTOS_PRESENTACION
}
